export const icons = {
  home:
    '\n' +
    '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM5.4 10.758C3.03 10.464 1.2 8.448 1.2 6C1.2 5.628 1.248 5.274 1.326 4.926L4.2 7.8V8.4C4.2 9.06 4.74 9.6 5.4 9.6V10.758ZM9.54 9.234C9.384 8.748 8.94 8.4 8.4 8.4H7.8V6.6C7.8 6.27 7.53 6 7.2 6H3.6V4.8H4.8C5.13 4.8 5.4 4.53 5.4 4.2V3H6.6C7.26 3 7.8 2.46 7.8 1.8V1.554C9.558 2.268 10.8 3.99 10.8 6C10.8 7.248 10.32 8.382 9.54 9.234Z" fill="white"/>\n' +
    '</svg>',
  shareholders:
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 30 30" xml:space="preserve">\n' +
    '<path class="st1" d="M21.6,14.9c2.1,0,3.7-1.6,3.7-3.6s-1.7-3.6-3.7-3.6s-3.7,1.6-3.7,3.6S19.6,14.9,21.6,14.9z M10.4,13.5\n' +
    '\tc2.5,0,4.5-1.9,4.5-4.3s-2-4.3-4.5-4.3S6,6.8,6,9.2S8,13.5,10.4,13.5z M21.6,17.7c-2.7,0-8.2,1.3-8.2,3.9v3.2h16.4v-3.2\n' +
    '\tC29.8,19,24.3,17.7,21.6,17.7z M10.4,16.3C7,16.3,0,18,0,21.3v3.6h10.4v-3.2c0-1.2,0.5-3.3,3.5-4.9C12.7,16.4,11.4,16.3,10.4,16.3z"\n' +
    '\t/>\n' +
    '</svg>',
  voting:
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">\n' +
    '<path class="st1" d="M22.5,8.4l-1.8-1.8l-8.1,8.2l1.8,1.8L22.5,8.4z M27.9,6.6L14.4,20.2L9,14.9l-1.8,1.8l7.2,7.2L29.8,8.4L27.9,6.6\n' +
    '\tz M0,16.7l7.2,7.2L9,22.1l-7.1-7.2L0,16.7z"/>\n' +
    '</svg>',
  financial:
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">\n' +
    '<style type="text/css">\n' +
    '\t.st0{opacity:0;fill:#FFFFFF;fill-opacity:0;}\n' +
    '\t.st1{fill:#FFFFFF;}\n' +
    '</style>\n' +
    '<rect class="st0" width="30" height="30"/>\n' +
    '<path class="st1" d="M27,3.7H3.1c-1.7,0-3,1.3-3,2.8v16.9c0,1.6,1.3,2.8,3,2.8H27c1.7,0,3-1.3,3-2.8V6.5C29.9,5,28.6,3.7,27,3.7z\n' +
    '\t M27,23.4H3.1V15H27V23.4z M27,9.3H3.1V6.5H27V9.3z"/>\n' +
    '</svg>',
  marketplace:
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">\n' +
    '<style type="text/css">\n' +
    '\t.st0{fill:#FFFFFF;fill-opacity:0;}\n' +
    '\t.st1{fill:#FFFFFF;}\n' +
    '</style>\n' +
    '<rect y="-0.1" class="st0" width="30" height="30"/>\n' +
    '<path class="st1" d="M6.7,13.3L0,19.7l6.7,6.4v-4.8h11.7v-3.2H6.7V13.3z M30,10.1l-6.6-6.4v4.8H11.7v3.2h11.7v4.8L30,10.1z"/>\n' +
    '</svg>',
  legal:
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">\n' +
    '<style type="text/css">\n' +
    '\t.st0{fill:#FFFFFF;fill-opacity:0;}\n' +
    '\t.st1{fill:#FFFFFF;}\n' +
    '</style>\n' +
    '<rect y="-0.1" class="st0" width="30" height="30"/>\n' +
    '<path class="st1" d="M4.2,12.8v10h4.4v-10H4.2z M12.9,12.8v10h4.4v-10H12.9z M1.2,30h27.7v-4.3H1.2V30z M21.6,12.8v10H26v-10H21.6z\n' +
    '\t M15.1,0L1.2,7.1V10h27.7V7.1L15.1,0z"/>\n' +
    '</svg>',
  approvals:
    '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">\n' +
    '<style type="text/css">\n' +
    '\t.st0{fill:#FFFFFF;fill-opacity:0;}\n' +
    '\t.st1{fill:#FFFFFF;}\n' +
    '</style>\n' +
    '<rect y="-0.1" class="st0" width="30" height="30"/>\n' +
    '<path class="st1" d="M27.1,2.5h-24c-1.7,0-3,1.4-3,3.1l0,18.8c0,1.7,1.4,3.1,3,3.1h24c1.6,0,3-1.4,3-3.1V5.6\n' +
    '\tC30.1,3.9,28.7,2.5,27.1,2.5z M27.1,8.8l-12,7.8l-12-7.8V5.6l12,7.8l12-7.8V8.8z"/>\n' +
    '</svg>\n',
  notification:
    '<svg style="width:32px;height:32px" viewBox="0 0 24 24">' +
    '<path fill="white" d="M4,2C2.89,2 2,2.89 2,4V14H4V4H14V2H4M8,6C6.89,6 6,6.89 6,8V18H8V8H18V6H8M12,10C10.89,10 10,10.89 10,12V20C10,21.11 10.89,22 12,22H20C21.11,22 22,21.11 22,20V12C22,10.89 21.11,10 20,10H12Z" />' +
    '</svg>'
};
